<template>
  <OfferPayment
    :isOpen="isOfferPaymentOpen"
    :lead="subscription"
    :product="subscription.product"
    :customer="subscription.customer"
    @sendFailedPaymentLink="$emit('sendFailedPaymentLink')"
    @closePaymentModal="$emit('closePaymentModal', $event)"
    @updateOffer="$emit('updateOffer', $event)"
  />
  <ContractConsultationModal
    :isOpen="isContractConsultationModalOpen"
    :offerCategory="subscription.category"
    :acknowledgements="contractAcknowledgements"
    :advisoryAgreementUrl="subscription.advisoryAgreement"
    :informationNoticeLinkUrl="subscription.informationNoticeLink"
    :productInformationSheetLinkUrl="subscription.productInformationSheetLink"
    :canContinue="canContinueToOfferPayment"
    @update:acknowledgements="contractAcknowledgements = $event"
    @close="closeContractConsultationModal"
    @continue="continueToOfferPayment"
  />
</template>

<script>
import ContractConsultationModal from "@/components/pos/subscription/formwithsteps/ContractConsultationModal.vue";
import OfferPayment from "@/components/pos/subscription/payment/OfferPayment.vue";
import { createInitialAcknowledgements } from "./subscriptionDefaults";

export default {
  name: "SubscriptionModals",
  components: {
    ContractConsultationModal,
    OfferPayment,
  },
  props: {
    subscription: {
      type: Object,
      required: true,
    },
  },
  emits: ["sendFailedPaymentLink", "closePaymentModal", "updateOffer"],
  data() {
    return {
      isOfferPaymentOpen: false,
      isContractConsultationModalOpen: false,
      contractAcknowledgements: createInitialAcknowledgements(),
    };
  },
  computed: {
    canContinueToOfferPayment() {
      return (
        this.contractAcknowledgements.advisoryAgreementViewed &&
        this.contractAcknowledgements.informationNoticeViewed &&
        this.contractAcknowledgements.productInformationSheetViewed &&
        this.contractAcknowledgements.insuranceConsent &&
        this.contractAcknowledgements.digitalDeliveryConsent
      );
    },
  },
  methods: {
    closeContractConsultationModal() {
      this.isContractConsultationModalOpen = false;
    },
    continueToOfferPayment() {
      if (!this.canContinueToOfferPayment) return;
      this.isContractConsultationModalOpen = false;
      this.isOfferPaymentOpen = true;
    },
    openContractConsultation() {
      this.contractAcknowledgements = createInitialAcknowledgements();
      this.isContractConsultationModalOpen = true;
    },
    reset() {
      this.isOfferPaymentOpen = false;
      this.isContractConsultationModalOpen = false;
      this.contractAcknowledgements = createInitialAcknowledgements();
    },
  },
};
</script>
